import { useMutation } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";

type ResendInvitePayload = {
  id: string;
};
export const useResendInvite = () => {
  return useMutation({
    mutationFn: async (payload: ResendInvitePayload) => {
      const res = await client.admin.invitation[":id"].resend.$post({
        param: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "invitation"] });
    },
  });
};
